<template>
   <div class="">

       <modal-wf
            v-bind="getInputProps({

            })"
       >
           <template #header-title>
               <slot name="header-title"></slot>
           </template>
           <template #trigger="{click}">
               <slot name="trigger" :click="click">
                   <a href="#" class="position-absolute top right h3 my-3 mx-3" @click="click">
                       <i class="fa fa-pencil" aria-hidden="true"></i>
                   </a>
               </slot>
           </template>
           <template #body="{ close }">
               <div class="card-body">

                   <slot name="content" :icon="icon" :title="title" :text="text" :msg="msg" :isError="isError">
                       <div class="row">
                           <div class="col-auto mx-auto">
                               <template v-if="icon">
                                   <div class="p-9 bg-contain" :style="'background-image: url('+icon+');'"></div>
                               </template>
                               <template v-else>
                                   <span class="display-1 m-0">
                                        <i :class="iconFont"></i>
                                   </span>
                               </template>
                           </div>
                       </div>
                       <div class="row">
                           <div class="col">
                               <div class="h3 font-weight-normal text-black text-center">
                                   {{ title }}
                               </div>
                               <div class="p text-gray text-center mt-4">
                                   {{ text }}
                               </div>

                               <template v-if="isError">
                                   <div class="h5 text-danger text-center mt-4">
                                       {{ msg }}
                                   </div>
                               </template>
                           </div>
                       </div>
                   </slot>

                   <div class="row mt-5">
                       <div class="col">
                           <form-ajax ref="formAjax">
                               <template #default="{ submit, getError, loading, msg }">
                                   <form :action="url" :method="method" @submit.prevent="submit">
                                        <template v-if="token">
                                           <input type="hidden" name="_token" :value="token">
                                        </template>
                                        <slot
                                                name="fields"
                                                :fields="fields"

                                                :submit="submit"
                                                :getError="getError"
                                                :loading="loading"
                                                :msg="msg"
                                        >
                                            <template v-for="field in fields">
                                                <input type="hidden" :name="field.name" :value="field.value">
                                            </template>
                                        </slot>

                                        <button type="submit" class="btn btn-lg btn-gradient-blue text-uppercase w-100">
                                            {{ confirmLabel }}
                                        </button>
                                   </form>
                               </template>
                           </form-ajax>
                       </div>
                       <div class="col">
                           <button class="btn btn-lg btn-outline-danger text-uppercase w-100" @click.prevent="close">
                               {{ rejectLabel }}
                           </button>
                       </div>
                   </div>

               </div>

           </template>

       </modal-wf>

   </div>
</template>

<script>
    import mixinCommon from './mixinCommon';

    import Modal from './Modal';
    import FormAjax from './FormAjax';

    export default {
        mixins: [ mixinCommon ],
        components: {
            'modal-wf': Modal,
            'form-ajax': FormAjax
        },
        props: {
            ...Modal.props,

            modalClassName: {
                type: String,
                default: 'modal-md'
            },

            url: {
                type: String,
                default: ''
            },
            method: {
                type: String,
                default: ''
            },

            title: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            },
            iconFont: {
                type: String,
                default: 'fa fa-trash-o text-danger'
            },

            confirmLabel: {
                type: String,
                default: 'yes'
            },
            rejectLabel: {
                type: String,
                default: 'no'
            },

            showHeader: {
                type: [Boolean, Number, String],
                default: false
            },
            showFooter: {
                type: [Boolean, Number, String],
                default: false
            },

            token: {
                type: String,
                default: ''
            },
            fields: {
                type: Array,
                default: () => []
            },

            defaultMsg: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                msg: this.defaultMsg,
                isError: false
            };
        },
        mounted() {
            let formAjax = this.$refs.formAjax;
            formAjax.$watch('msg', ( response ) => {
                this.msg = formAjax.$data.msg;
                this.isError = formAjax.$data.isError;
            });
        },
        methods: {
            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( Modal, overrideProps );
            }
        }
    }
</script>
